module.exports = __webpack_public_path__ + "media/Bee.7c94c21e.mp4";